import { Tabs } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ACTIVE_TAB } from '@/consts/searchKeys';
import { useComparisonFilterTabsActive } from '@/hooks/useComparisonFilterTabsActive';
import { useQueryParam } from '@/hooks/useQueryParam';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { ComparisonFilterTab, Tab } from '@/types/tabs';

interface ComparisonFilterTabsProps {
  primaryName: string;
  comparisonName: string;
  primaryFilters: ReactNode;
  comparisonFilters?: ReactNode;
}

const validTabValues = Object.values(ComparisonFilterTab);

export const ComparisonFilterTabs = ({
  primaryName,
  comparisonName,
  primaryFilters,
  comparisonFilters,
}: ComparisonFilterTabsProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTabParam = useQueryParam(ACTIVE_TAB);
  const updateQueryString = useUpdateQueryString(searchParams);
  const tabsActive = useComparisonFilterTabsActive();

  if (!tabsActive) return primaryFilters;

  const tabs: Tab<ComparisonFilterTab>[] = [
    { value: ComparisonFilterTab.PRIMARY, label: primaryName },
    { value: ComparisonFilterTab.COMPARISON, label: comparisonName },
  ];

  // guard against invalid activeTab values in the url
  const activeTab = validTabValues.find(tab => tab === activeTabParam) || ComparisonFilterTab.PRIMARY;

  return (
    <div className="flex h-full flex-col">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(_: MouseEvent, { value }: Tab<ComparisonFilterTab>) =>
          navigate({ search: updateQueryString([{ key: ACTIVE_TAB, value }]) })
        }
      />
      <div className="h-full overflow-y-auto">
        {activeTab === ComparisonFilterTab.PRIMARY ? primaryFilters : comparisonFilters}
      </div>
    </div>
  );
};
